import { render, staticRenderFns } from "./send_check.vue?vue&type=template&id=3ae23338&"
import script from "./send_check.vue?vue&type=script&lang=js&"
export * from "./send_check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports